import React from "react";
import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";

export const canSendMessages = (user) => !!user && (user.is_pro || user.role === "admin");

export const ProChatLock = ({ what = "send messages", testId = "pro-chat-lock" }) => (
  <div
    className="flex flex-col sm:flex-row sm:items-center gap-3 p-3 border-t hairline bg-[#fff4ee]"
    data-testid={testId}
  >
    <div className="flex items-start gap-2 flex-1 min-w-0">
      <Lock className="w-4 h-4 text-[#ff4500] mt-0.5 shrink-0" />
      <p className="text-xs text-[#444] leading-relaxed">
        You can read along for free. <strong>CampCompass Pro</strong> members can {what}.
      </p>
    </div>
    <Link
      to="/pro"
      className="btn-primary text-xs px-4 py-2 inline-flex items-center justify-center gap-1.5 shrink-0"
      data-testid={`${testId}-upgrade`}
    >
      <Sparkles className="w-3.5 h-3.5" /> Go Pro
    </Link>
  </div>
);
